import Vue from 'vue'

const account = {
  state: {
    loginId: '',
    trueName: '',
    homePath: '',
    bindInfo: null
  },
  mutations: {
    saveAccount: function (state, {loginId, trueName, homePath, bindInfo}) {
      state.loginId = loginId
      state.trueName = trueName
      state.homePath = homePath
      state.bindInfo = bindInfo
    }
  },
  actions: {
    loadAccount: function (context) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$ajax({
          url: '/workspace/manager/center/basicInfo',
          method: 'post'
        }).then((response) => {
          let data = response.data
          if (data) {
            context.commit('saveAccount', data)
            let themeStyle = data['themeStyle']
            if (themeStyle) {
              context.commit('chooseThemeStyle', themeStyle)
            } else {
              context.commit('chooseDefaultTheme')
            }
            resolve()
          } else {
            context.commit('chooseDefaultTheme')
            reject(new Error('没有返回结果'))
          }
        }, err => {
          context.commit('chooseDefaultTheme')
          reject(err)
        })
      })
    }
  }
}

export default account
